export const defaultCountry = "Deutschland";
export const defaultCountryCode = "DE";
